import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MaterialEnterstoreApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialEnterstore'
  }

}